import messages from './messages.tsx';

export const successFlagConfig = {
	type: 'success',
	title: messages.feedbackSuccessFlagTitle,
	description: messages.feedbackSuccessFlagDescription,
	isAutoDismiss: true,
} as const;
